import { isBitSet, readHexInt } from "./hex";
import { getProtocolString } from "./source";

const ALERT_DEFINITIONS = [
  { id: 1, name: "纯水比例异常", kind: "fault", bit: 11 },
  { id: 2, name: "供水低压保护", kind: "fault", bit: 10 },
  { id: 3, name: "供水液位故障", kind: "fault", bit: 9 },
  { id: 4, name: "原水箱缺水", kind: "fault", bit: 8 },
  { id: 5, name: "原水箱液位故障", kind: "fault", bit: 7 },
  { id: 6, name: "纯水箱液位故障", kind: "fault", bit: 6 },
  { id: 7, name: "膜前压力传感器故障", kind: "fault", bit: 5 },
  { id: 8, name: "膜前压力保护", kind: "fault", bit: 4 },
  { id: 9, name: "供水压力传感器故障", kind: "fault", bit: 3 },
  { id: 10, name: "进水压力过低", kind: "fault", bit: 2 },
  { id: 11, name: "纯水箱缺水", kind: "fault", bit: 1 },
  { id: 12, name: "进水压力传感器故障", kind: "fault", bit: 0 },
  { id: 13, name: "软化树脂", kind: "maintenance", bit: 6 },
  { id: 14, name: "再生盐", kind: "maintenance", bit: 5 },
  { id: 15, name: "RO/NF膜", kind: "maintenance", bit: 3 },
  { id: 16, name: "石英砂", kind: "maintenance", bit: 2 },
  { id: 17, name: "精密滤芯", kind: "maintenance", bit: 1 },
  { id: 18, name: "活性炭", kind: "maintenance", bit: 0 }
];

export function parseAlerts(protocol) {
  const runningState = getProtocolString(protocol, "runningState");
  const faultValue = readHexInt(runningState, 6, 4);
  const maintenanceValue = readHexInt(runningState, 10, 4);

  const alerts = ALERT_DEFINITIONS.map(definition => {
    const active = isBitSet(
      definition.kind === "fault" ? faultValue : maintenanceValue,
      definition.bit
    );

    return {
      id: definition.id,
      name: definition.name,
      type: active ? definition.kind : "normal"
    };
  });

  return {
    alerts,
    faultCount: alerts.filter(alert => alert.type === "fault").length,
    maintenanceCount: alerts.filter(alert => alert.type === "maintenance")
      .length
  };
}
